import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import ULPackageBuilder from '../../components/specials/home/UnlimitedPackage';

Builder.registerComponent(ULPackageBuilder, {
    name: BUILDER_DIVIDER_NAMES.UnlimitedPackage,
});
